import { stringLiteral } from '@execonline-inc/decoders';
import { identity } from '@kofno/piper';
import { Decoder, array, field, maybe, number, oneOf, string, succeed } from 'jsonous';
import {
  PreviewEndOfStream,
  PreviewStreamBase,
  StreamedPreview,
  StreamedPreviewMessage,
} from './Types';

const previewStreamBaseDecoder: Decoder<PreviewStreamBase> = succeed({})
  .assign('turnUUID', field('turn_uuid', string))
  .assign('seq', maybe(field('seq', number)))
  .map<PreviewStreamBase>(identity);

// The service fills name, description and the id list one message at a time,
// so a missing or null value means "no change", the same as an empty one.
const stringOrEmpty = (name: string): Decoder<string> =>
  maybe(field(name, string)).map((value) => value.getOrElseValue(''));

const streamedPreviewDecoder: Decoder<StreamedPreview> = previewStreamBaseDecoder
  .assign('type', field('type', stringLiteral('preview')))
  .assign('name', stringOrEmpty('name'))
  .assign('description', stringOrEmpty('description'))
  .assign(
    'recommendedProgramFamilyIds',
    maybe(field('recommended_program_family_ids', array(number))).map((ids) =>
      ids.getOrElseValue([]),
    ),
  );

const previewEndOfStreamDecoder: Decoder<PreviewEndOfStream> = previewStreamBaseDecoder.assign(
  'type',
  field('type', stringLiteral('end-of-stream')),
);

export const streamedPreviewMessageDecoder: Decoder<StreamedPreviewMessage> =
  oneOf<StreamedPreviewMessage>([
    streamedPreviewDecoder.map<StreamedPreviewMessage>(identity),
    previewEndOfStreamDecoder.map<StreamedPreviewMessage>(identity),
  ]);
